<template>
  <nav aria-label="Breadcrumb">
    <ul class="flex items-center space-x-4">
      <li v-if="homeRoute">
        <router-link
          :to="{ name: 'Dashboard' }"
          class="flex items-center justify-center space-x-2 text-sm transition-all hover:text-white"
        >
          <i v-html="$icons.home" class="transition-all hover:text-white"></i>
          <span class="sr-only">Página inicial</span>
        </router-link>
      </li>

      <template v-for="route in path">
        <i v-html="$icons.chevron_right" :key="'icon_' + route.label"></i>
        <li :key="'link_' + route.label">
          <div
            class="flex items-center justify-center space-x-2 text-sm transition-all"
            v-if="!route.navigable"
          >
            <span class="transition-all">
              {{ route.label }}
            </span>
          </div>

          <router-link
            v-else
            :to="{ name: route.routeName }"
            class="flex items-center justify-center space-x-2 text-sm transition-all hover:text-white"
          >
            <span class="transition-all hover:text-white">
              {{ route.label }}
            </span>
          </router-link>
        </li>
      </template>
    </ul>
  </nav>
</template>

<script>
export default {
  props: {
    homeRoute: {
      type: Boolean,
      default: true,
    },
    path: {
      type: Array,
    },
  },
};
</script>

<style></style>
